import { css } from '@emotion/react';

interface LexicalTableStylesOptions {
  tableClass: string;
  tableCellClass: string;
  tableCellHeaderClass: string;
  borderColor: string;
  headerBackgroundColor: string;
}

export function createLexicalTableStyles({
  tableClass,
  tableCellClass,
  tableCellHeaderClass,
  borderColor,
  headerBackgroundColor,
}: LexicalTableStylesOptions) {
  return css`
    .${tableClass} {
      border-collapse: collapse;
      border-spacing: 0;
      max-width: 100%;
    }

    .${tableCellClass} {
      border-color: ${borderColor};
      border-style: solid;
      border-width: 1px;
      min-width: 0;
      overflow-wrap: anywhere;
      padding: var(--chakra-space-1) var(--chakra-space-2);
      text-align: start;
      vertical-align: top;
    }

    .${tableCellHeaderClass} {
      background-color: ${headerBackgroundColor};
      text-align: start;
    }
  `;
}
